exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h3[data-v-de2ec478],h4[data-v-de2ec478]{text-align:center}table[data-v-de2ec478]{margin-left:33%;margin-right:auto}td[data-v-de2ec478]{padding:0 0 8px 5px;word-wrap:break-word;width:405px}img[data-v-de2ec478]{padding-right:5px;height:20px}@media (max-width:1200px){table[data-v-de2ec478]{margin-left:29%}}@media (max-width:991px){table[data-v-de2ec478]{margin-left:25%}}@media (max-width:768px){table[data-v-de2ec478]{margin-left:20%}}@media (max-width:500px){table[data-v-de2ec478]{margin-left:13%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-de2ec478","scoped":true,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/banned-account/banned-account.vue
// module id = 866
// module chunks = 0